import Helpers from '@helpers';
import * as React from 'react';
import OrderSummaryHelper from '../order-summary/order_summary';
import { Order, State } from './model';
import './styles.css';

class Cart extends React.Component<{}, State> {
    public LinkButton; constructor(props) {
        super(props);
        this.state = this.getInitialState();
    }
    

    public componentDidMount() {
        Helpers.LoadingHelper.showLoading();
        Helpers.ApiHelper.removeUnavailableCartItems().then(_ => {
            this.reloadCart();
        }).always(_ => {
            Helpers.LoadingHelper.hideLoading();
        });

        OrderSummaryHelper.buttonAction = this.buttonAction;
    }

    public componentDidUpdate(prevProps, prevState: State) {
        const cartTotal = this.state.items &&
            this.state.items.reduce((acc, cur) => acc + cur.price * cur.quantity, 0);

        const cartDiscount = this.state.items &&
            this.state.items.reduce((acc, cur) => acc + cur.discount * cur.quantity, 0);

        OrderSummaryHelper.setCartTotal(cartTotal, cartDiscount);
    }

    public render() {
        const itemsTemplate =
            this.state &&
            this.state.items &&
            this.state.items.map(item => this.getItemsTemplate(item));
        var cartEmpty;

        if (itemsTemplate == null) {
            cartEmpty == null;
        } else if (this.isEmpty(itemsTemplate)) {
            cartEmpty = 1;
        } else {
            cartEmpty = 0;
        }
        if (cartEmpty == null) {
            return (
                <div className="loading"></div>
            );
        } else if (cartEmpty === 0) {
            var objKey = Object.keys(itemsTemplate);
            var i = objKey.length;
            var numStr = i.toString();
            document.getElementById('lblCartItems').innerHTML = numStr;
            return (
                <div className='cart-container'>
                    {itemsTemplate}
                </div>
            );
            
        }

        else {
            document.getElementById('lblCartItems').innerHTML = "0";
            return (
                <div className="empty-cart">
                    <img src="/content/public/image/Cart-empty.png" />
                    <h2>
                        سبد خرید شما خالی است!
                    </h2>
                    <p>
                        شما می توانید با ورود به حساب کاربری خود، محصولات امروز را خریداری کنید.
                    </p>
                    <div className="empty-cart-link-wrapper">
                        <a href="/ProductList/sb.Bazdid/sd.false/im.true/ipp.40/t.true/" className="epmty-cart-link">
                            صفحه پیشنهاد ویژه   
                        </a>
                    </div>
                </div>
            );
        }
    }


    private isEmpty = (obj) => {
        for (var key in obj) {
            if (obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }


    private buttonAction = () => {
        Helpers.LoadingHelper.showLoading();
        const quantities = this.state.items.map(x => ({
            orderId: x.id,
            quantity: x.quantity
        }));

        Helpers.ApiHelper.saveCartItems(quantities).then(_ => {
            location.replace('/order/');
        }).catch(_ => {
            location.reload();
        }).always(_ => {
            // don't hide loading until navigates to the new page
            // Helpers.LoadingHelper.hideLoading();
        });
    }

    private getInitialState = () => ({
        items: null,
        
    })

    private reloadCart = () => {
        Helpers.LoadingHelper.showLoading();
        Helpers.ApiHelper.getCartItems().then(items => {
            this.setState({
                items
            });
        }).always(_ => {
            Helpers.LoadingHelper.hideLoading();
        });
    }

    private getQuantityOptions = (item: Order) => {
        let quantity = 500;
        if (item.maxQuantity) {
            quantity = Math.min(quantity, item.maxQuantity);
        }
        if (item.maxPerOrder) {
            quantity = Math.min(quantity, item.maxPerOrder);
        }
        let quantityArray = [...Array(quantity + 1).keys()];
        quantityArray = quantityArray.slice(1, quantity + 1);
        let options = quantityArray.map(x => <option key={x} value={x}>{x}</option>);
        if (item.quantity > quantity) {
            options.push(<option>{item.quantity}</option>)
        }
        return options;
    }

    private getWarantyPrefix = (item) => {
        let prefix=""
        if (item!=null && !item.includes("گارانتی")) {
            prefix="گارانتی"
        }
        return prefix;
    }

    private getItemsTemplate = (item: Order) =>
        <div key={item.id} className='cart-item-container' id='cartItem'>
            <p className="cart-express-shipping" style={{ display: item.expressShipping ? 'block' : 'none' }}>ارسال فوری، کمتر از 24 ساعت کاری</p>
            <div className='cart-item'>
                <p className="cart-special-offer" style={{ display: item.featured ? 'block' : 'none' }} >پیشنهاد ویژه</p>
                
                <span onClick={() => this.removeCartItem(item.id)}
                    className='cart-item-remove'>
                    <i className='cart-item-remove-link'></i>
                </span>

                <a className='cart-item-image-container'
                    href={item.productLink}>
                    <img src={item.productImage} />
                </a>

                <div className='cart-item-details-container'>
                    <div className='cart-item-details'>

                        <div className='cart-item-title-container'>
                            <span className='cart-item-product-title'>
                                {item.productTitle}
                            </span>
                            <span className='cart-item-variation-title color'>
                                <div className="cart-item-color-box list-item list-item-color" style={{ backgroundColor: item.colorCode }}></div>
                                {item.color}
                            </span>
                            <span className='cart-item-variation-title warranty'>
                                {this.getWarantyPrefix(item.warranty)} {item.warranty}, {item.priceTitle}
                            </span>
                            <div className='cart-item-message-container'>
                                <div className='alert-box alert-error'
                                    style={{ display: this.getNotEnoughQuantityErrorStyle(item) }}>
                                    موجودی باقیمانده این محصول
                            {` ${Helpers.Utils.ConvertToPersianDigit(item.maxQuantity)} `}
                                    عدد است.
                            </div>
                                <div className='alert-box alert-error'
                                    style={{ display: this.getForbiddenQuantityErrorStyle(item) }}>
                                    حداکثر تعداد قابل خرید از این محصول
                            {` ${Helpers.Utils.ConvertToPersianDigit(item.maxPerOrder)} `}
                                    عدد است.
                            </div>
                            </div>
                        </div>

                        <div className='cart-item-qantity-container'>
                            {/* <span className='cart-item-qantity-caption'>
                            تعداد
                        </span> */}
                            <select
                                value={item.quantity}
                                onChange={this.selectQuantity(item)}
                                className='cart-item-qantity-dropdown'>
                                {this.getQuantityOptions(item)}
                            </select>
                        </div >
                    </div>

                    <div className='cart-item-price-container'>
                        <span className='cart-item-price'>
                            {Helpers.Utils.formatPrice(this.getTotalPrice(item))}
                        </span>
                    </div>


                </div>
            </div>
            
        </div>

    private removeCartItem(orderId: number) {
        Helpers.LoadingHelper.showLoading();
        Helpers.ApiHelper.removeCartItem(orderId).then(_ => {
            this.reloadCart();
        }).always(_ => {
            Helpers.LoadingHelper.hideLoading();
        });
    }

    private getTotalPrice = (item: Order) => (item.price - item.discount ) * item.quantity;

    private selectQuantity = (item: Order) => e => {
        const items = this.state &&
            this.state.items.map(x => {
                if (x.id === item.id) {
                    return {
                        ...x,
                        quantity: e.target.value
                    };
                } else {
                    return x;
                }
            });

        this.setState({
            items
        });
    }

    private getNotEnoughQuantityErrorStyle = (item: Order) => {
        if (item.maxQuantity) {
            if (item.quantity > item.maxQuantity) {
                return 'block';
            } else {
                return 'none';
            }
        }

        return 'none';
    }

    private getForbiddenQuantityErrorStyle = (item: Order) => {
        if (item.maxPerOrder) {
            if (item.quantity > item.maxPerOrder) {
                return 'block';
            } else {
                return 'none';
            }
        }

        return 'none';
    }
}

Helpers.ReactHelper.createReactElement('Cart', Cart);
